import { render, staticRenderFns } from "./PolizasRMSTabs.vue?vue&type=template&id=f5e66bc0&scoped=true&"
import script from "./PolizasRMSTabs.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e66bc0",
  null
  
)

export default component.exports